import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, Input, message, Modal, Upload } from 'antd';
import React, { useState } from 'react';
import { useArea } from '../../../context/AreaContext';
import api, { fileUpload } from '../../../services/api';
import { negativeFeedback } from '../../../utils/feedback';

interface IProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  getPartners: () => void;
}

const NewPartner: React.FC<IProps> = ({ visible, setVisible, getPartners }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fileList, setFileList] = useState<Array<any>>([]);
  const { area } = useArea();
  const handleVisible = () => {
    setVisible(false);
    handleRemove();
  };

  const handleUpload = (e: any) => {
    setFileList([e]);

    return false;
  };

  const handleRemove = () => {
    setFileList([]);
  };

  const handleSubmit = async (data: any) => {
    setLoading(true);
    try {
      const { name, link } = data;
      const image = await fileUpload(fileList[0], 'image', '/image');
      await api.post(`/${area.endpoint}/partner`, {
        name,
        link,
        image,
      });
      setVisible(false);
      setLoading(false);
      handleRemove();
      getPartners();
    } catch (err) {
      setLoading(false);
      message.error(negativeFeedback);
    }
  };

  return (
    <Modal
      title="Novo Parceiro"
      onCancel={handleVisible}
      visible={visible}
      footer={null}
    >
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Logo"
          name="image"
          rules={[
            {
              required: true,
              message: 'Por favor, faça o upload do arquivo!',
            },
            () => ({
              validator() {
                if (fileList.length === 0) {
                  return Promise.reject(
                    new Error('Por favor, faça o upload do arquivo!'),
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Upload
            accept=".jpg, .jpeg, .png, .webp"
            beforeUpload={handleUpload}
            onRemove={handleRemove}
            fileList={fileList}
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Carregar Arquivo</Button>
          </Upload>
        </Form.Item>
        <Form.Item
          label="Nome do Parceiro"
          name="name"
          rules={[
            {
              required: true,
              message: 'Por favor, informe o nome do parceiro!',
            },
          ]}
        >
          <Input placeholder="Informe o nome do parceiro" />
        </Form.Item>
        <Form.Item
          label="Site do Parceiro"
          name="link"
          rules={[
            {
              required: true,
              message: 'Por favor, informe o site do parceiro!',
            },
          ]}
        >
          <Input placeholder="Informe o site do parceiro" />
        </Form.Item>
        <Form.Item>
          <Button loading={loading} type="primary" block htmlType="submit">
            Cadastrar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default NewPartner;
